import { ANALYTICS_SCHEMA_VERSION, type AnalyticsEventName, type AnalyticsIdentity, type CompletedMatchAnalytics, type SessionSnapshot } from './contract';

type AnalyticsProperty = string | number | boolean | null;

export class AnalyticsClient {
  constructor(
    private readonly identity: AnalyticsIdentity,
    private readonly enabled: () => boolean,
    private readonly basePath = '/api/analytics',
  ) {}

  event(name: AnalyticsEventName, properties: Readonly<Record<string, AnalyticsProperty>> = {}): void {
    if (!this.enabled()) return;
    const payload = {
      schemaVersion: ANALYTICS_SCHEMA_VERSION,
      eventId: crypto.randomUUID(),
      anonymousId: this.identity.anonymousId,
      sessionId: this.identity.sessionId,
      name,
      occurredAt: new Date().toISOString(),
      properties,
    };
    this.post('/event', payload);
  }

  session(snapshot: SessionSnapshot, useBeacon = false): void {
    if (!this.enabled()) return;
    if (useBeacon && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(`${this.basePath}/session`, new Blob([JSON.stringify(snapshot)], { type: 'application/json' }));
      return;
    }
    this.post('/session', snapshot);
  }

  match(summary: CompletedMatchAnalytics): void {
    if (!this.enabled()) return;
    this.post('/match', summary);
  }

  private post(path: string, body: unknown): void {
    void fetch(`${this.basePath}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
      credentials: 'same-origin',
    }).then((response) => {
      if (!response.ok) throw new Error(`Analytics request failed with ${response.status}`);
    }).catch(() => {
      // Analytics is deliberately best-effort and must never affect gameplay.
    });
  }
}
